import axios from 'axios';
import { ROOT_URL } from '../config/global';

export const FETCH_PAGES = 'FETCH_PAGES';
export const FETCH_PAGES_SUCCESS = 'FETCH_PAGES_SUCCESS';
export const FETCH_PAGES_FAILURE = 'FETCH_PAGES_FAILURE';

export const fetchPages = (result) => {
    axios.defaults.withCredentials = true;

    const request = axios({
        method: 'get',
        url: `${ROOT_URL}/api/pages`,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Cache': 'no-cache',
        }
    },
    {withCredentials: true});

    return {
        type: FETCH_PAGES,
        payload: request
    };
}

export function fetchPagesSuccess(response) {
  return {
    type: FETCH_PAGES_SUCCESS,
    payload: response
  };
}

export function fetchPagesFailure(error) {
  return {
    type: FETCH_PAGES_FAILURE,
    payload: error
  };
}


// WEBPACK FOOTER //
// ./src/redux/actions/pages.js